import { sanitizeData } from './sanitizeData';

/**
 * Safe logger: only logs in development and always sanitizes data
 * so customer-sensitive fields are never printed to the console.
 * Uses NODE_ENV (set to 'production' by the build) so nothing logs in prod.
 */

const isDev = process.env.REACT_APP_NODE_ENV === 'development';

/**
 * @param {string} message - Error message
 * @param {*} [error] - Optional error; will be sanitized before logging
 */
export function safeError(message, error = null) {
  if (!isDev) return;
  if (error !== undefined && error !== null) {
    try {
      const sanitized =
        typeof error === 'object'
          ? {
              message: error?.message,
              stack: error?.stack,
              response: error?.response
                ? {
                    status: error.response.status,
                    statusText: error.response.statusText,
                    data: sanitizeData(error.response?.data ?? {}),
                  }
                : undefined,
            }
          : error;
      console.error(message, sanitized);
    } catch {
      console.error(message);
    }
  } else {
    console.error(message);
  }
}

/**
 * @param {string} message - Warning message
 * @param {*} [data] - Optional data; will be sanitized
 */
export function safeWarn(message, data = null) {
  if (!isDev) return;
  if (data !== undefined && data !== null) {
    try {
      const sanitized =
        typeof data === 'object' ? sanitizeData(data) : data;
      console.warn(message, sanitized);
    } catch {
      console.warn(message);
    }
  } else {
    console.warn(message);
  }
}

